// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"footer_wrapper__PIKm4","buttonContainer":"footer_buttonContainer__62PLf"};